import { render, staticRenderFns } from "./AccountPreferences.vue?vue&type=template&id=516f0866&scoped=true&"
import script from "./AccountPreferences.vue?vue&type=script&lang=js&"
export * from "./AccountPreferences.vue?vue&type=script&lang=js&"
import style0 from "./AccountPreferences.vue?vue&type=style&index=0&id=516f0866&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516f0866",
  null
  
)

export default component.exports